<template>
  <topbar
    :titulo="$t('ACADEMICO.TIPO_AVALIACOES')"
    :subtitulo="$t('ACADEMICO.TIPO_AVALIACAO_CEJ_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-md-4">
        <div></div>
        <b-button
          @click="cadastrar"
          variant="info"
          class="mr-2"
          v-if="podeCadastrar"
        >
          {{ $t('GERAL.CADASTRAR') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
<script>
//Components:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
        { titulo: 'ACADEMICO.TIPO_AVALIACOES' },
      ],
    };
  },
  methods: {
    // FUNÇÕES CRUD:
    cadastrar() {
      this.$emit('cadastrar', 'tipoAvaliacao');
    },
  },
};
</script>
